import { ReactNode } from 'react';
import { Box, Center, Loader, Paper } from '@mantine/core';
import { LogoWithIcon, HEADER_HEIGHT } from 'src/UI/app-container/header/Header';

interface AuthPageLayoutProps {
  isLoading?: boolean;
  withHeader?: boolean;
  withPaper?: boolean;
  children?: ReactNode;
}

export const AuthPageLayout = ({
  isLoading = false,
  withHeader = false,
  withPaper = false,
  children,
}: AuthPageLayoutProps) => {
  const centerHeight = withHeader ? `calc(100vh - ${HEADER_HEIGHT}px)` : '100%';

  const renderContent = () => {
    if (isLoading) {
      return <Loader color="gray.0" size="lg" />;
    }

    if (withPaper) {
      return (
        <Paper bg="gray.0" radius="xl" py={48} px={84} w={490}>
          {children}
        </Paper>
      );
    }

    return children;
  };

  return (
    <Box bg="gray.10" h="100vh">
      {withHeader && (
        <Box h={HEADER_HEIGHT} px="xxl" style={{ display: 'flex', alignItems: 'center' }}>
          <LogoWithIcon textColor="gray.0" />
        </Box>
      )}

      <Center h={centerHeight}>{renderContent()}</Center>
    </Box>
  );
};
